import { Box, FormControl, FormHelperText, FormLabel, Switch } from '@chakra-ui/react'

import { useAddPlayerContext } from '@contexts/AddPlayerContext'

const DISABLED_HELPER_TEXT = 'Only one captain could be selected on each team'

export function CaptainSwitch() {
    const { newPlayer, enableCaptainEdit, patchPlayer } = useAddPlayerContext()
    const isCaptain = newPlayer?.captain ?? false
    const onChange = (value: boolean) => {
        patchPlayer({ captain: value })
    }

    return (
        <FormControl>
            <Box display="flex" alignItems="center">
                <FormLabel mb={0}>Set as captain</FormLabel>
                <Switch
                    tabIndex={-1}
                    disabled={!enableCaptainEdit}
                    isChecked={isCaptain}
                    onChange={e => onChange(Boolean(e.target.checked))}
                />
            </Box>
            {!enableCaptainEdit && <FormHelperText>{DISABLED_HELPER_TEXT}</FormHelperText>}
        </FormControl>
    )
}
